import React from 'react';
import { createUseStyles } from 'react-jss';
import { layoutDefaults } from '../../utils/layout-defaults';
import { PaymentDetails } from './payment-details';
import { PixQRCode } from './pix-qr-code';

function PaymentPixQRCodeModalBody({
  payment,
  analyticsFeatureUseEvent,
  spot,
  menuInfo,
  feature,
}) {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <PixQRCode
        className={classes.qrcode}
        analyticsFeatureUseEvent={analyticsFeatureUseEvent}
        // analyticsHollowEvent={analyticsHollowEvent}
        payload={payment?.pix?.payload}
      />
      <PaymentDetails
        payment={payment}
        spot={spot}
        menuInfo={menuInfo}
        feature={feature}
      />
    </div>
  );
}

const useStyles = createUseStyles({
  container: {
    fontSize: layoutDefaults.fontSize,
    marginTop: -layoutDefaults.smallVerticalMargin,

    // border: '1px solid red',
  },
  qrcode: {
    // marginBottom: layoutDefaults.smallVerticalMargin,
  },
});

export { PaymentPixQRCodeModalBody };
